import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserPermission } from '../../../features/auth/models/permissions';
import { CognitoAuthService } from '../../../features/auth/services/cognito-auth.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectTrackerGuard {
  constructor(
    private cognitoAuthService: CognitoAuthService,
    private router: Router
  ) {}

  canActivate() {
    const user = this.cognitoAuthService.loggedInUser;
    const isAuthorized = user?.permissions.has(
      UserPermission.ProjectTrackerRead
    );

    if (!isAuthorized) {
      this.router.navigate(['']);
      return false;
    }

    return isAuthorized;
  }
}
